/**
 * Static 데코레이터
 * 타입스크립트 인터페이스에 스테틱을 선언할 수 없다.
 * 스테틱 메소드나 변수를 제한하기 위해 @Static<T>() 와 함께 사용하여 스테틱 구현을 유도
 * 코딩/컴파일 타임 때 체크가 되어야 하므로 @bizform/type 에 포함
 * @since 0.0.1
 * @author Heungsoo,Ham
 * @function
 */
export function Static<T>() {
    return (constructor: T) => {};
}
